import { useAppHardwareBack } from "../hooks/useAppHardwareBack";

/**
 * Wires centralized hardware-Back policy into App.js without rendering UI.
 */
export function AppHardwareBackBridge({
  screen,
  onNavigateToKpi,
  onAppWorkflowBack,
  overlays,
}) {
  useAppHardwareBack({
    screen,
    onNavigateToKpi,
    onAppWorkflowBack,
    overlays,
  });

  return null;
}
